<template>
  <div class="order_detail" v-if="loading">
    <nav-bar />
    <search-bar />
    <div class="main fz14">
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
            :to="{ path: '/me/myorder' }"
            v-if="$route.query.type != 'finance'"
          >我的订单</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/me/finance' }" v-else>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="info_box">
        <div class="info mb20">
          <div class="fr ac fz12 mt20">
            <div class="center order_list_item">产品信息</div>
            <div class="center order_list_item">产品规格</div>
            <div class="center order_list_item">设备信息</div>
            <div class="center order_list_item">配套工艺</div>
            <div class="center order_list_item">产品价格</div>
            <div class="center order_list_item">数量</div>
            <div class="center order_list_item">小计</div>
          </div>
          <el-divider />
          <div class="order-list fz12">
            <div class="order-item mt20">
              <!--                上-->
              <div class="top">
                <span>{{order_detail.create_time}}</span>
                <span class="ml20 grey">订单编号：{{order_detail.order_no}}</span>
                <span class="ml40 blue" v-html="order_state_decide(order_detail)"></span>
              </div>
              <!--                中-->

              <div class="fr middle">
                <!-- 商品信息 -->
                <div class="order">
                  <div
                    class="fr jc ac order_left"
                    v-for="(goods,i) in order_detail.orderGoodsBeans"
                    :key="i"
                  >
                    <div class="fr afs pl10 pr20 pt20 pb20 order_list_item">
                      <el-image class="goods_img fs mr10" :src="goods.goods_img" alt />
                      <p class>{{goods.goods_name}} {{goods.goods_standard_name}}</p>
                    </div>
                    <div class="center order_list_item"> {{ specNameInit(goods) }}</div>
                    <div class="center order_list_item">{{goods.device_id?goods.device_id:'-'}}</div>

                    <div class="center cursor order_list_item blue">
                      {{goods.goods_type==1?
                      "￥"+goods.goods_craft_price:'-'}}
                    </div>
                    <div class="center order_list_item">￥{{goods.goods_price}}</div>
                    <div class="center order_list_item">{{goods.goods_num}}</div>
                    <div class="center order_list_item red">￥{{goods.goods_total_price}}</div>
                  </div>
                </div>
              </div>

              <!--                下-->
              <div class="p20 fz14 bottom" style="text-align: right">
                <div>
                  <span>订单金额</span>
                  <span class="blue">￥{{order_detail.order_total_price}}</span>
                </div>
                <div class="mt10">
                  <span>已付款</span>
                  <span>￥{{order_detail.pay_price}}</span>
                </div>
                <div class="mt10">
                  <span>未付款</span>
                  <span class="red">￥{{sub(order_detail.order_actual_price,order_detail.pay_price)}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="price_box" v-if="loading">
          <div class="price_item">
            <div class="fr afs pt20 pb20">
              <span class="fs">反馈描述：</span>
              <el-input
                :value="feedback_detail.feedback_desc"
                style="width:40%"
                disabled
                type="textarea"
                resize="none"
                rows="3"
                size="mini"
              />
            </div>
          </div>
          <div
            class="price_item mb20"
            v-if="feedback_detail.feedback_imgs && feedback_detail.feedback_imgs.length"
          >
            <div class="fr afs pt20 pb20">
              <span class="fs">反馈图片：</span>
              <div class="fr ac">
                <el-image
                  :src="i"
                  v-for="(i,k) in feedback_detail.feedback_imgs.split(',')"
                  :key="k"
                  class="mr10"
                  :preview-src-list="feedback_detail.feedback_imgs.split(',')"
                />
              </div>
            </div>
          </div>
          <el-divider />

          <div class="price_item">
            <div class="fr afs pt20 pb20">
              <span class="fs">回复内容：</span>
              <el-input
                :value="feedback_detail.feedback_reply || '暂未回复！'"
                style="width:40%"
                disabled
                type="textarea"
                resize="none"
                rows="3"
                size="mini"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-bar />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
import Upload from "@/components/UploadImg";
export default {
  data() {
    return {
      order_detail: {},
      feedback_detail: {},
      loading: false,
      contract_name: "",
      contract_imgs: []
    };
  },
  created() {
    this.getOrderDetail();
    this.getOrderFeedbackDetail();
  },
  methods: {
    // 订单详情
    getOrderDetail() {
      this.post("orderInterfaces/v1.0/getOrderDetail", {
        order_id: this.$route.query.id
      }).then(res => {
        this.order_detail = res.data;
      });
    },
    getOrderFeedbackDetail() {
      this.loading = false;
      this.post("orderInterfaces/v1.0/getOrderFeedbackDetail", {
        order_id: this.$route.query.id
      }).then(res => {
        this.feedback_detail = res.data;
        this.loading = true;
      });
    }
  },
  components: { NavBar, SearchBar, FooterBar, "up-load": Upload }
};
</script>

<style scoped lang="scss">
.order_detail {
  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    .nav {
      background-color: #fff;
      padding: 20px;
      margin-bottom: 20px;
    }
    .info_box {
      background-color: #fff;
      padding: 20px;
      .info {
        background-color: #fff;
        .order_list_item {
          &:nth-of-type(1) {
            width: 400px;
          }
          &:nth-of-type(2) {
            width: 130px;
          }
          &:nth-of-type(3) {
            width: 130px;
          }
          &:nth-of-type(4) {
            width: 130px;
          }
          &:nth-of-type(5) {
            width: 130px;
          }
          &:nth-of-type(6) {
            width: 130px;
          }
          &:nth-of-type(7) {
            width: 130px;
          }
        }
        .order-list {
          .order-item {
            border: 1px solid #e5e5e5;
            .top {
              background-color: #f0f6ff;
              padding: 14px;
            }
            .middle {
              border-bottom: 1px solid #e5e5e5;
              .order {
                .order_left {
                  border-right: 1px solid #e5e5e5;
                  border-bottom: 1px solid #e5e5e5;
                  &:last-child {
                    border-bottom: none;
                  }
                  .goods_img {
                    width: 80px;
                    height: 80px;
                  }
                }
                .operating {
                  p {
                    margin-top: 10px;
                    &:nth-of-type(1) {
                      margin-top: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .price_box {
        .price_item {
          .el-image {
            width: 100px;
            height: 100px;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myorder/Feedbackdetail.vue